module.exports = __webpack_public_path__ + "static/media/screenshot_desktop.23e28aae.png";